<!-- Layout -->
@if (coreConfig) {

  <vertical-layout
    [ngClass]="validateSidebar"
  ></vertical-layout>

}
